import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Core translations (auth, nav, grid, common — always present in every project)
import coreTR from "../i18n/core/tr.json";
import coreEN from "../i18n/core/en.json";
import coreAR from "../i18n/core/ar.json";
import coreJA from "../i18n/core/ja.json";

// Feature translations (screen-specific — delete/replace per project)
import featureTR from "../i18n/features/tr.json";
import featureEN from "../i18n/features/en.json";
import featureAR from "../i18n/features/ar.json";
import featureJA from "../i18n/features/ja.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "tr", "ar", "ja"];

const resources = {
  en: { translation: { ...coreEN, ...featureEN } },
  tr: { translation: { ...coreTR, ...featureTR } },
  ar: { translation: { ...coreAR, ...featureAR } },
  ja: { translation: { ...coreJA, ...featureJA } },
};
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    supportedLngs: availableLanguages,

    detection: {
      checkWhitelist: true,
    },
    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
